'use strict';


// Export EBP Isabelle ISO-8859(-1?)
// https://www.convertcsv.com/csv-to-json.htm

export const CONST_TARIFS = [
  {
    "Code article": "ANGLE_GD",
    "Libellé": "Angle abri GRAND Lg 2100 RAL",
    "PV HT": "23,40000",
    "Masse": "3,15"
  },
  {
    "Code article": "ATG-G3/3",
    "Libellé": "Option ATG pour Abri G3 Long. 3 m + Kit traitement ISOFIBRE",
    "PV HT": "38,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G3/4",
    "Libellé": "Option ATG pour Abri G3 Long. 4 m + Kit traitement ISOFIBRE",
    "PV HT": "46,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G3/5",
    "Libellé": "Option ATG pour Abri G3 Long. 5 m + Kit traitement ISOFIBRE",
    "PV HT": "54,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G3/6",
    "Libellé": "Option ATG pour Abri G3 Long. 6 m + Kit traitement ISOFIBRE",
    "PV HT": "62,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G4/3",
    "Libellé": "Option ATG pour Abri G4 Long. 3 m + Kit traitement ISOFIBRE",
    "PV HT": "45,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G4/4",
    "Libellé": "Option ATG pour Abri G4 Long. 4 m + Kit traitement ISOFIBRE",
    "PV HT": "56,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G4/5",
    "Libellé": "Option ATG pour Abri G4 Long. 5 m + Kit traitement ISOFIBRE",
    "PV HT": "66,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G4/6",
    "Libellé": "Option ATG pour Abri G4 Long. 6 m + Kit traitement ISOFIBRE",
    "PV HT": "77,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G5/3",
    "Libellé": "Option ATG pour Abri G5 Long. 3 m + Kit traitement ISOFIBRE",
    "PV HT": "53,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G5/4",
    "Libellé": "Option ATG pour Abri G5 Long. 4 m + Kit traitement ISOFIBRE",
    "PV HT": "66,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G5/5",
    "Libellé": "Option ATG pour Abri G5 Long. 5 m + Kit traitement ISOFIBRE",
    "PV HT": "79,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "ATG-G5/6",
    "Libellé": "Option ATG pour Abri G5 Long. 6 m + Kit traitement ISOFIBRE",
    "PV HT": "92,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "B_PIGNON-G3-2.55",
    "Libellé": "Bardage PIGNON Prof. 3 m Haut. 2.55 m RAL",
    "PV HT": "309,00000",
    "Masse": "83,82"
  },
  {
    "Code article": "B_PIGNON-G3-3.3",
    "Libellé": "Bardage PIGNON Prof. 3 m Haut. 3.3 m RAL",
    "PV HT": "347,00000",
    "Masse": "130,84"
  },
  {
    "Code article": "B_PIGNON-G4-2.55",
    "Libellé": "Bardage PIGNON Prof. 4 m Haut. 2.55 m RAL",
    "PV HT": "352,00000",
    "Masse": "121,67"
  },
  {
    "Code article": "B_PIGNON-G4-3.3",
    "Libellé": "Bardage PIGNON Prof. 4 m Haut. 3.3 m RAL",
    "PV HT": "422,00000",
    "Masse": "163,20"
  },
  {
    "Code article": "B_PIGNON-G5-2.55",
    "Libellé": "Bardage PIGNON Prof. 5 m Haut. 2.55 m RAL",
    "PV HT": "380,00000",
    "Masse": "143,17"
  },
  {
    "Code article": "B_PIGNON-G5-3.3",
    "Libellé": "Bardage PIGNON Prof. 5 m Haut. 3.3 m RAL",
    "PV HT": "512,00000",
    "Masse": "195,35"
  },
  {
    "Code article": "B3-LP_BAS-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 3 m RAL",
    "PV HT": "162,00000",
    "Masse": "63,26"
  },
  {
    "Code article": "B3-LP_BAS-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 3 m RAL",
    "PV HT": "163,00000",
    "Masse": "64,16"
  },
  {
    "Code article": "B3-LP_BAS-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 3 m RAL",
    "PV HT": "164,00000",
    "Masse": "65,06"
  },
  {
    "Code article": "B3-LP_BAS-3.05",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 3 m RAL",
    "PV HT": "209,00000",
    "Masse": "76,82"
  },
  {
    "Code article": "B3-LP_BAS-3.1",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 3 m RAL",
    "PV HT": "211,00000",
    "Masse": "77,71"
  },
  {
    "Code article": "B3-LP_BAS-3.15",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long.. 3 m RAL",
    "PV HT": "212,00000",
    "Masse": "78,61"
  },
  {
    "Code article": "B3-LP_HAUT-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long.. 3 m RAL",
    "PV HT": "168,00000",
    "Masse": "68,10"
  },
  {
    "Code article": "B3-LP_HAUT-3.3",
    "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 3 m RAL",
    "PV HT": "216,00000",
    "Masse": "81,66"
  },
  {
    "Code article": "B3-LPBAS_RP-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 3 m + Réservation Porte RAL",
    "PV HT": "314,00000",
    "Masse": "65,06"
  },
  {
    "Code article": "B3-LPBAS_RP-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 3 m + Réservation Porte RAL",
    "PV HT": "316,00000",
    "Masse": "94,56"
  },
  {
    "Code article": "B3-LPBAS_RP-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 3 m + Réservation Porte RAL",
    "PV HT": "318,00000",
    "Masse": "96,08"
  },
  {
    "Code article": "B3-LPH_RP-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 3 m + Réservation Porte RAL",
    "PV HT": "324,00000",
    "Masse": "100,94"
  },
  {
    "Code article": "B4-LP_BAS-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 4 m RAL",
    "PV HT": "198,00000",
    "Masse": "84,19"
  },
  {
    "Code article": "B4-LP_BAS-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 4 m RAL",
    "PV HT": "200,00000",
    "Masse": "85,39"
  },
  {
    "Code article": "B4-LP_BAS-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 4 m RAL",
    "PV HT": "201,00000",
    "Masse": "86,59"
  },
  {
    "Code article": "B4-LP_BAS-3.05",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 4 m RAL",
    "PV HT": "259,00000",
    "Masse": "102,27"
  },
  {
    "Code article": "B4-LP_BAS-3.1",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long.  4 m RAL",
    "PV HT": "260,00000",
    "Masse": "103,47"
  },
  {
    "Code article": "B4-LP_BAS-3.15",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 4 m RAL",
    "PV HT": "262,00000",
    "Masse": "104,67"
  },
  {
    "Code article": "B4-LP_HAUT-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 4 m RAL",
    "PV HT": "207,00000",
    "Masse": "90,65"
  },
  {
    "Code article": "B4-LP_HAUT-3.3",
    "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m  Long. 4 m RAL",
    "PV HT": "267,00000",
    "Masse": "108,73"
  },
  {
    "Code article": "B4-LPBAS_RP-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 4 m + Réservation Porte RAL",
    "PV HT": "329,00000",
    "Masse": "101,89"
  },
  {
    "Code article": "B4-LPBAS_RP-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 4 m + Réservation Porte RAL",
    "PV HT": "332,00000",
    "Masse": "103,71"
  },
  {
    "Code article": "B4-LPBAS_RP-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 4 m + Réservation Porte RAL",
    "PV HT": "334,00000",
    "Masse": "105,54"
  },
  {
    "Code article": "B4-LPH_RP-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 4 m + Réservation Porte  RAL",
    "PV HT": "341,00000",
    "Masse": "111,00"
  },
  {
    "Code article": "B5-LP_BAS-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 5 m RAL",
    "PV HT": "242,00000",
    "Masse": "106,59"
  },
  {
    "Code article": "B5-LP_BAS-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 5 m RAL",
    "PV HT": "244,00000",
    "Masse": "108,08"
  },
  {
    "Code article": "B5-LP_BAS-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 5 m RAL",
    "PV HT": "246,00000",
    "Masse": "109,58"
  },
  {
    "Code article": "B5-LP_BAS-3.05",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  Long. 5 m RAL",
    "PV HT": "323,00000",
    "Masse": "127,73"
  },
  {
    "Code article": "B5-LP_BAS-3.1",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 5 m RAL",
    "PV HT": "325,00000",
    "Masse": "129,23"
  },
  {
    "Code article": "B5-LP_BAS-3.15",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 5 m RAL",
    "PV HT": "326,00000",
    "Masse": "130,73"
  },
  {
    "Code article": "B5-LP_HAUT-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 5 m RAL",
    "PV HT": "252,00000",
    "Masse": "114,66"
  },
  {
    "Code article": "B5-LP_HAUT-3.3",
    "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 5 m RAL",
    "PV HT": "333,00000",
    "Masse": "135,80"
  },
  {
    "Code article": "B5-LPBAS_RP-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 5 m + Réservation Porte RAL",
    "PV HT": "371,00000",
    "Masse": "134,89"
  },
  {
    "Code article": "B5-LPBAS_RP-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 5 m + Réservation Porte RAL",
    "PV HT": "373,00000",
    "Masse": "137,02"
  },
  {
    "Code article": "B5-LPBAS_RP-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 5 m + Réservation Porte  RAL",
    "PV HT": "376,00000",
    "Masse": "139,14"
  },
  {
    "Code article": "B5-LPH_RP-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 5 m + Réservation Porte  RAL",
    "PV HT": "384,00000",
    "Masse": "146,03"
  },
  {
    "Code article": "B6-LP_BAS-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 6 m RAL",
    "PV HT": "278,00000",
    "Masse": "127,52"
  },
  {
    "Code article": "B6-LP_BAS-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 6 m RAL",
    "PV HT": "280,00000",
    "Masse": "129,31"
  },
  {
    "Code article": "B6-LP_BAS-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 6 m RAL",
    "PV HT": "283,00000",
    "Masse": "131,11"
  },
  {
    "Code article": "B6-LP_BAS-3.05",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 3.05 m  lLong. 6 m RAL",
    "PV HT": "380,00000",
    "Masse": "153,19"
  },
  {
    "Code article": "B6-LP_BAS-3.1",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 3.1 m  Long. 6 m RAL",
    "PV HT": "382,00000",
    "Masse": "154,98"
  },
  {
    "Code article": "B6-LP_BAS-3.15",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 3.15 m Long. 6 m RAL",
    "PV HT": "384,00000",
    "Masse": "156,78"
  },
  {
    "Code article": "B6-LP_HAUT-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 6 m RAL",
    "PV HT": "291,00000",
    "Masse": "137,20"
  },
  {
    "Code article": "B6-LP_HAUT-3.3",
    "Libellé": "Bardage Long Pan HAUT Haut. 3.3 m Long. 6 m RAL",
    "PV HT": "392,00000",
    "Masse": "162,87"
  },
  {
    "Code article": "B6-LPBAS_RP-2.3",
    "Libellé": "Bardage G5 Long Pan BAS Haut. 2.3 m  Long. 6 m + Réservation Porte RAL",
    "PV HT": "381,00000",
    "Masse": "143,75"
  },
  {
    "Code article": "B6-LPBAS_RP-2.35",
    "Libellé": "Bardage G4 Long Pan BAS Haut. 2.35 m  Long. 6 m + Réservation Porte RAL",
    "PV HT": "384,00000",
    "Masse": "146,18"
  },
  {
    "Code article": "B6-LPBAS_RP-2.4",
    "Libellé": "Bardage G3 Long Pan BAS Haut. 2.4 m Long. 6 m + Réservation Porte RAL",
    "PV HT": "387,00000",
    "Masse": "148,60"
  },
  {
    "Code article": "B6-LPH_RP-2.55",
    "Libellé": "Bardage Long Pan HAUT Haut. 2.55 m Long. 6 m + Réservation Porte  RAL",
    "PV HT": "397,00000",
    "Masse": "187,95"
  },
  {
    "Code article": "BANDEAU_FAITAGE",
    "Libellé": "Bandeau de faîtage (en 2 éléments) Lg 2100 RAL...",
    "PV HT": "32,10000",
    "Masse": "3,50"
  },
  {
    "Code article": "FAITIERE_SOLIN",
    "Libellé": "Faîtière en solin Lg 2100 RAL...",
    "PV HT": "28,50000",
    "Masse": "2,10"
  },
  {
    "Code article": "PACL",
    "Libellé": "Pince pour réalisation de larmier en bas de pente pour tôle ATG PRO",
    "PV HT": "19,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "REJET_EAU",
    "Libellé": "Rejet d'eau Lg 2100 RAL...",
    "PV HT": "21,00000",
    "Masse": "1,58"
  },
  {
    "Code article": "REM-QTE",
    "Libellé": "Remise quantité",
    "PV HT": "-145,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "RIVE_GDE",
    "Libellé": "Rive abri GRANDE Lg 2100 RAL...",
    "PV HT": "22,50000",
    "Masse": "2,52"
  },
  {
    "Code article": "RIVE_SOLIN",
    "Libellé": "Rive solin Lg 2100 RAL...",
    "PV HT": "18,50000",
    "Masse": "2,10"
  },
  {
    "Code article": "SP-G3-2.55/3",
    "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 3 m RAL",
    "PV HT": "980,00000",
    "Masse": "252,00"
  },
  {
    "Code article": "SP-G3-2.55/4",
    "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 4 m RAL",
    "PV HT": "1 047,00000",
    "Masse": "290,52"
  },
  {
    "Code article": "SP-G3-2.55/5",
    "Libellé": "Abri Simple pente Prof.3 m Haut 2.55 m -5% Long. 5 m RAL",
    "PV HT": "1 126,00000",
    "Masse": "328,86"
  },
  {
    "Code article": "SP-G3-2.55/6",
    "Libellé": "Abri Simple pente Prof. 3 m Haut 2.55 m -5% Long. 6 m RAL",
    "PV HT": "1 213,00000",
    "Masse": "372,85"
  },
  {
    "Code article": "SP-G3-3.3/3",
    "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 3 m RAL",
    "PV HT": "1 064,00000",
    "Masse": "303,79"
  },
  {
    "Code article": "SP-G3-3.3/4",
    "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 4 m RAL",
    "PV HT": "1 131,00000",
    "Masse": "348,50"
  },
  {
    "Code article": "SP-G3-3.3/5",
    "Libellé": "Abri Simple pente Prof.3 m Haut 3.3 m -5% Long. 5 m RAL",
    "PV HT": "1 213,00000",
    "Masse": "401,18"
  },
  {
    "Code article": "SP-G3-3.3/6",
    "Libellé": "Abri Simple pente Prof. 3 m Haut 3.3 m -5% Long. 6 m RAL",
    "PV HT": "1 301,00000",
    "Masse": "447,79"
  },
  {
    "Code article": "SP-G4-2.55/3",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 3 m RAL",
    "PV HT": "1 034,00000",
    "Masse": "284,44"
  },
  {
    "Code article": "SP-G4-2.55/4",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 4 m RAL",
    "PV HT": "1 111,00000",
    "Masse": "328,95"
  },
  {
    "Code article": "SP-G4-2.55/5",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 5 m RAL",
    "PV HT": "1 196,00000",
    "Masse": "373,28"
  },
  {
    "Code article": "SP-G4-2.55/6",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 2.55 m -5% Long. 6 m RAL",
    "PV HT": "1 300,00000",
    "Masse": "425,80"
  },
  {
    "Code article": "SP-G4-3.3/3",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 3 m RAL",
    "PV HT": "1 118,00000",
    "Masse": "355,57"
  },
  {
    "Code article": "SP-G4-3.3/4",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 4 m RAL",
    "PV HT": "1 195,00000",
    "Masse": "412,56"
  },
  {
    "Code article": "SP-G4-3.3/5",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 5 m RAL",
    "PV HT": "1 282,00000",
    "Masse": "477,50"
  },
  {
    "Code article": "SP-G4-3.3/6",
    "Libellé": "Abri Simple pente Prof. 4 m Haut 3.3 m -5% Long. 6 m RAL",
    "PV HT": "1 381,00000",
    "Masse": "536,38"
  },
  {
    "Code article": "SP-G5-2.55/3",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 3 m RAL",
    "PV HT": "1 105,00000",
    "Masse": "333,34"
  },
  {
    "Code article": "SP-G5-2.55/4",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 4 m RAL",
    "PV HT": "1 194,00000",
    "Masse": "389,64"
  },
  {
    "Code article": "SP-G5-2.55/5",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 5 m RAL",
    "PV HT": "1 295,00000",
    "Masse": "446,74"
  },
  {
    "Code article": "SP-G5-2.55/6",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 2.55 m -5% Long. 6 m RAL",
    "PV HT": "1 411,00000",
    "Masse": "511,60"
  },
  {
    "Code article": "SP-G5-3.3/3",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 3 m RAL",
    "PV HT": "1 200,00000",
    "Masse": "390,22"
  },
  {
    "Code article": "SP-G5-3.3/4",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 4 m RAL",
    "PV HT": "1 289,00000",
    "Masse": "453,18"
  },
  {
    "Code article": "SP-G5-3.3/5",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 5 m RAL",
    "PV HT": "1 392,00000",
    "Masse": "524,15"
  },
  {
    "Code article": "SP-G5-3.3/6",
    "Libellé": "Abri Simple pente Prof. 5 m Haut 3.3 m -5% Long. 6 m RAL",
    "PV HT": "1 509,00000",
    "Masse": "589,09"
  },
  {
    "Code article": "TRANS-G3",
    "Libellé": "Option Translucides pour Abris G3 Long. 2 m qté : 2 tôles",
    "PV HT": "54,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "TRANS-G4",
    "Libellé": "Option Translucides pour Abris G4 Long. 2,5 m qté : 2 tôles",
    "PV HT": "60,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "TRANS-G5",
    "Libellé": "Option Translucides pour Abris G5 Long. 2 m qté : 2 tôles",
    "PV HT": "54,00000",
    "Masse": "0,00"
  },
  {
    "Code article": "LIVRAISON",
    "Libellé": "Livraison et déchargement hors îles et stations de montagne",
    "PV HT": "0,00000",
    "Masse": "0,00"
  }
 ];
